import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { ClubApi, ClubGridDto, ClubSearch } from "../../../../api";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ViewButton, EditButton, SearchTablePage } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";

export interface IClublistPageProps {}

export const ClublistPage: React.FunctionComponent<IClublistPageProps> = (props) => {
  const api = useApiService(ClubApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ClubGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.club}/${row.clubId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.club}/${row.clubId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.FinalNumber),
        fieldName: "finalNumber",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.club}/0/detail/edit`);
  }, [history]);

  const search = React.useCallback(
    (sObj) => api.baseSearch(ClubSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(ClubSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }))
      }
      addFunc={addItemFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Clubs) }]}
    />
  );
};
